export type CampaignCompany = {
  name: string
  clicks: number
  views: number
  share: number
  status: string
  companyUuid: string
}

export const emptyCampaignCompany = (): CampaignCompany => ({
  name: '',
  clicks: 0,
  views: 0,
  share: 0,
  status: '',
  companyUuid: '',
})

export const campaignCompaniesFromServer = (x?: any): CampaignCompany =>
  x
    ? {
        name: x.name,
        clicks: x.clicks,
        views: x.views,
        share: x.share,
        status: x.status,
        companyUuid: x.uuid,
      }
    : emptyCampaignCompany()

export const getCampaignCompaniesQuery = meta => ({
  limit: meta.rowsPerPage,
  offset: meta.page * meta.rowsPerPage,
})
